import { injectIntl } from 'react-intl';
import * as models from '@app/models';
import Injector from '@app/services';
import {
	Grid,
	Typography,
	Accordion,
	AccordionSummary,
	AccordionDetails,
	MenuItem,
	TextField,
	Box,
	Chip,
} from '@material-ui/core';
import React from 'react';
import { CarrierPaymentTypeEnum } from '@app/app.enum';
import Icon from '@app/components/shared/icon.component';

import { IntlService } from '@app/services/intl.service';
import { StyleRules, withStyles } from '@material-ui/core/styles';

import { AdminCarrierAccountService } from '@app/services/admin-carrier-account.service';

const styles: StyleRules = {
	card: {
		cursor: 'pointer',
	},
};

const intlService: IntlService = Injector.get(IntlService);
const adminCarrierAccountService: AdminCarrierAccountService = Injector.get(AdminCarrierAccountService);

const PaymentModeConfigComponent: React.FunctionComponent<models.IPaymentModeConfigProps> = (props) => {
	return (
		<Accordion className='mb-2' defaultExpanded={props.defaultExpandAccordion}>
			<AccordionSummary expandIcon={<Icon name='chevron-down' />}>
				<Grid container={true} direction='row' justifyContent='space-evenly'>
					<Grid item={true} xs={12}>
						<Typography variant='h6' color='inherit'>
							{intlService.GetFormattedMessage('app.carrier-card.accordin-payment-mode-label')}
						</Typography>
					</Grid>
				</Grid>
			</AccordionSummary>
			<AccordionDetails style={{ maxHeight: '186px !important' }} className='flex-column'>
				<TextField
					variant='outlined'
					margin='normal'
					size='small'
					select={true}
					fullWidth={true}
					value={props.configDialogContent.paymentType ?? props.userCarrier.carrierPaymentType}
					label={intlService.GetFormattedMessage('app.carrier-card.payment-type-label')}
					onChange={async (e: React.ChangeEvent<HTMLInputElement>) => {
						props.setConfigDialogContent((prevState: models.ICarrierAccountConfigDialog) => ({
							...prevState,
							paymentType: e.target.value as CarrierPaymentTypeEnum,
						}));

						await adminCarrierAccountService.updateCarrierAccountConfigForAdmin(props.userCarrier.id, {
							paymentType: e.target.value as CarrierPaymentTypeEnum,
						});

						props.setUserCarrierDetails((prevState) => ({
							...prevState,
							paymentType: e.target.value as CarrierPaymentTypeEnum,
						}));

						props.openSnackBar(
							intlService.GetFormattedMessage('app.snackbar.carrier-account-config-update-successful')
						);
					}}
					SelectProps={{
						renderValue: (value: string) => {
							return value === props.userCarrier.carrierPaymentType ? (
								<Grid container={true} alignItems='center'>
									<Grid item={true}>
										{value} - {intlService.GetFormattedMessage(`carrier.${value}.description`)}{' '}
									</Grid>
									<Box mx={1} />
									<Grid item={true}>
										<Chip
											label={intlService.GetFormattedMessage('app.carrier-card.carrier-payment-type-label')}
											color='primary'
										/>
									</Grid>
								</Grid>
							) : (
								<>
									{value} - {intlService.GetFormattedMessage(`carrier.${value}.description`)}
								</>
							);
						},
						MenuProps: {
							PaperProps: {
								style: {
									maxHeight: '250px',
								},
							},
						},
					}}
				>
					{Object.entries(CarrierPaymentTypeEnum).map(([key, value]: [string, string], index: number) => (
						<MenuItem key={index} value={value}>
							{key === props.userCarrier.carrierPaymentType ? (
								<>
									{key} - {intlService.GetFormattedMessage(`carrier.${key}.description`)}
									<Box mx={1} />
									<Chip
										label={intlService.GetFormattedMessage('app.carrier-card.carrier-payment-type-label')}
										color='primary'
									/>
								</>
							) : (
								<>
									{key} - {intlService.GetFormattedMessage(`carrier.${key}.description`)}
								</>
							)}
						</MenuItem>
					))}
				</TextField>
			</AccordionDetails>
		</Accordion>
	);
};

export default injectIntl(withStyles(styles)(PaymentModeConfigComponent));



// WEBPACK FOOTER //
// ./src/components/carriers/payment-mode-config.component.tsx